import { codeSplit, Controller, FetchPageOptions } from 'bernie-core';
import { PageData } from 'bernie-http';
import { ClientLogger } from 'bernie-client';
import { PageId, getPageName } from 'utility';
import { getNavigationIdFromQuery } from 'utility/navigation-identity';
import { Localization } from 'bernie-l10n';

export class FlightsMerchandisingConfirmationController implements Controller {
  public pageId = PageId.FLIGHTS_MERCHANDISHING_CONFIRMATION;
  public path = '/trips/flight-add-ons-confirmation';
  public routeName = 'flight-add-ons-confirmation';
  public bundles = [];
  public exact = true;
  /* istanbul ignore next */
  public component = codeSplit(
    () => import(/* webpackChunkName: "servicing" */ '../views/flights-merchandising-confirmation')
  );
  public pendingPromises = [];
  private logger = ClientLogger.getLoggerWithIdentifier('controller.flightsMerchandisingConfirmation');

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public fetch(): Promise<any> {
    return Promise.resolve();
  }

  public fetchPageData(pageData: FetchPageOptions): Promise<PageData> {
    const localizer = new Localization(pageData.context.locale);
    const query = pageData.query;
    const title = localizer.formatText('fis.server.page.title');
    const pageName = getPageName(this.pageId);
    const navigationId = getNavigationIdFromQuery(query);

    return Promise.resolve({ title, pageId: this.pageId, pageName, navigationId });
  }
}
